'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDowOffset = getDowOffset;
exports.getDow = getDow;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var days = {
    MONDAY: 0,
    TUESDAY: 1,
    WEDNESDAY: 2,
    THURSDAY: 3,
    FRIDAY: 4,
    SATURDAY: 5,
    SUNDAY: 6
};

function getDowOffset(dow) {
    return (days[dow] + 1) % 7;
}

function getDow(dowOffset) {
    return _lodash2.default.findKey(days, function (offset) {
        return (offset + 1) % 7 === dowOffset % 7;
    });
}